export default "__VITE_ASSET__BtFX81pt__"